import React, {useState, useEffect} from 'react'
import {ResponsiveLine, Serie} from '@nivo/line'

interface DataPoint {
  x: string | undefined | null
  y: number | string | undefined
}

interface LineData {
  id: string
  data: DataPoint[]
}

interface MyLineChartProps {
  data?: LineData[]
  percent?: boolean
}

const MyLineChart: React.FC<MyLineChartProps> = ({data = [], percent = false}) => {
  function formatLargeNumber(num: number): string {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`
    } else if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}k`
    } else {
      if (percent) {
        return num.toString() + '%'
      } else {
        return num.toString()
      }
    }
  }
  useEffect(() => {
    setSum(
      Number(data[0]?.data[0]?.y ?? 0) +
        Number(data[0]?.data[1]?.y ?? 0) +
        Number(data[0]?.data[2]?.y ?? 0)
    )
    //  let formattedData: LineData[] = []
    //  if (data.length > 0) {
    //    formattedData = data.map((lineData) => ({
    //      ...lineData,
    //      data: lineData.data.map((point) => ({
    //        ...point,
    //        y: formatLargeNumber(Number(point.y ?? 0)),
    //      })),
    //    }))

    //    // Calculate sum of first three formatted y-values

    //  }
    //  console.log(formattedData)
    setDataGraph(data)
  }, [data])
  const [sum, setSum] = useState(0)
  const [dataGraph, setDataGraph] = useState(data)
  const colors = ['#3C85C1']

  const getPointColor = (point) => {
    // Define your logic here to determine colors based on point data
    // For example, if the y value is greater than 5, color it red, else blue
    return data[0]?.data[point.index]?.y === '0' ? 'black' : '#3C85C1'
  }
const getPointLable = (point) => {
  // Define your logic here to determine colors based on point data
    // For example, if the y value is greater than 5, color it red, else blue
      if (point.isMissing) return ''
    return formatLargeNumber(point.y)
}
  return (
    <div style={{marginTop: sum === 0 ? '45%' : '0', marginBottom: sum === 0 ? '-40%' : '0'}}>
      {' '}
      <div style={{height: '150px'}}>
        <ResponsiveLine
          margin={{top: 40, right: 16, bottom: 10, left: 16}}
          data={dataGraph as Serie[]} // Specify the type of data as Serie[]
          xScale={{type: 'point'}}
          enableGridX={false}
          enableGridY={false}
          axisTop={null}
          axisLeft={null}
          lineWidth={5}
          pointSize={1}
          colors={colors}
          pointColor={{theme: 'background'}}
          pointBorderWidth={11}
          //pointBorderColor={{from: 'serieColor', modifiers: []}}
          pointBorderColor={getPointColor}
          enablePointLabel={true}
          pointLabel={getPointLable}
          pointLabelYOffset={-16}
          enableArea={true}
          areaOpacity={0.15}
          isInteractive={true}
          enableCrosshair={false}
          useMesh={true}
          axisBottom={null}
        />
      </div>
    </div>
  )
}

MyLineChart.defaultProps = {
  data: [
    {
      id: 'numberUsersRsAlerts',
      data: [
        {x: 'week1', y: '0'},
        {x: 'week2', y: '0'},
        {x: 'week3', y: '0'},
      ],
    },
  ],
}

export default MyLineChart
